import { createStyles } from "@mantine/emotion";

export default createStyles ( theme => {
	return ( {
		modalContent: {
			backgroundColor : theme.other.colors.background.primary,
			flexBasis       : "auto",
			maxWidth        : "600px",
			minWidth        : "400px"
		},
		modalBody: {
			padding        : "1rem 2rem",
			display        : "flex",
			alignItems     : "center",
			justifyContent : "center",
			flexDirection  : "column",
			paddingTop     : "3rem"
		},
		closeIcon: {
			position : "absolute",
			right    : "0",
			top      : "0",
			margin   : "1.8rem",
			cursor   : "pointer"
		},
		btn: {
			padding: "0.75rem"
		},
		drawerContent: {
			height       : "unset",
			borderRadius : "2rem 2rem 0 0",
			padding      : "1rem",
			paddingTop   : "3rem"
		}
	} );
} );